import React, { memo } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import LottieGif from "../../../components/LottieGif";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'CopilotLoader');
const CopilotLoader = /*#__PURE__*/memo(_ref => {
  let {
    src
  } = _ref;
  const classes = useStyles();
  if (!src) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(LottieGif, {
    src: src
  }));
});
export default CopilotLoader;